/* unplugin-vue-components disabled */import script from "./RoleFinder.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleFinder.vue?vue&type=script&setup=true&lang=js"

import "./RoleFinder.vue?vue&type=style&index=0&id=51160720&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51160720"]])

export default __exports__